const doc = [({"en":({"js":({"admin":({"products":({"show":({"show_product_with_name":"Show product: %{name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;